import PropTypes from 'prop-types';

const RecentRatingType = PropTypes.shape({
  rating: PropTypes.string,
  created_at: PropTypes.string,
});

export const ReviewRatingType = PropTypes.shape({
  category: PropTypes.string,
  category_id: PropTypes.number,
  value: PropTypes.string,
});

export const StationCategoryRatingType = PropTypes.shape({
  category_id: PropTypes.number,
  total_ratings: PropTypes.number,
  positive: PropTypes.number,
  neutral: PropTypes.number,
  negative: PropTypes.number,
  recent_ratings: PropTypes.arrayOf(RecentRatingType),
});

export const StationCategoryRatingComparisonType = PropTypes.shape({
  category_id: PropTypes.number,
  total_ratings: PropTypes.number,
  positive: PropTypes.number,
  neutral: PropTypes.number,
  negative: PropTypes.number,
});

export const StationRatingsType = PropTypes.shape({
  id: PropTypes.number,
  star_rating: PropTypes.number,
  ratings_count_for_star_rating: PropTypes.number,
  categories: PropTypes.arrayOf(StationCategoryRatingType),
});

export const StationRatingCategoryScores = PropTypes.shape({
  category_id: PropTypes.number,
  category_name: PropTypes.string,
  label: PropTypes.string,
});
